<template>
    <div :class="`form__group ${ getClassDef('form__group') } ${ stacked ? 'form__group--stacked' : '' }`">
        <label v-if="labelText"
               :for="def"
               :class="`form__label ${ getClassDef('form__label') }`">{{ labelText }}</label>
        <div v-if="labelText"
             :class="`form__field-wrapper ${ getClassDef('form__field-wrapper') }`">
            <slot />
        </div>
        <slot v-else />
    </div>
</template>

<script>

export default {

    props: {
        def: {
            type: String,
            default: null,
        },
        labelText: {
            type: String,
            default: '',
        },
        stacked: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        /**
         * Create a CSS class in the format `prefix--def`.
         *
         * @param {string} prefix
         * @returns {string}
         */
        getClassDef(prefix) {
            return this.def ? `${ prefix }--${ this.def } --${ this.def }` : ''
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.

.form {

    @include element('group') {
        width: 100%;
        margin: 10px 0 5px 0;

        @include bp-min-small {
            display: flex;
            flex-direction: row;
            align-items: baseline;
        }

        @include modifier('stacked') {
            @include bp-min-small {
                display: block;
            }
        }
    }

    @include element('label') {
        display: block;
        width: 100%;
        padding-bottom: 5px;

        @include bp-min-small {
            padding-bottom: 0;
            width: auto;
            flex: 0, 1, auto;
            margin-right: 1em;
        }
    }

    @include element('field-wrapper') {
        width: 100%;

        @include bp-min-small {
            width: auto;
            flex: 1, 1, auto;
        }
    }
}

</style>
